import { render, staticRenderFns } from "./project-results.vue?vue&type=template&id=20103e1b&scoped=true"
import script from "./project-results.vue?vue&type=script&lang=js"
export * from "./project-results.vue?vue&type=script&lang=js"
import style0 from "./project-results.vue?vue&type=style&index=0&id=20103e1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20103e1b",
  null
  
)

export default component.exports